import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CategoryQuery, TopicLevel1Service } from '@examdojo/category/v2';
import { AssetTreeItem } from './model/asset-tree-node.model';

@Injectable({
  providedIn: 'root',
})
export class TopicsTreeService {
  constructor(
    private readonly topicLevel1Service: TopicLevel1Service,
    private readonly categoryQuery: CategoryQuery,
  ) {}

  private readonly activeTopicPath = signal<string | null>(null);
  readonly activeTopicPath$ = toObservable(this.activeTopicPath);

  setActivePath(id: string) {
    this.activeTopicPath.set(id);
  }

  create(..._: unknown[]) {
    // stub
  }

  async rename(..._: unknown[]) {
    // stub
  }

  async delete(..._: unknown[]) {
    // stub
  }

  async move(_: Array<{ id: AssetTreeItem['id']; to: string }>) {
    // stub
  }
}
